/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

const colors = {
	primary: "#6725F4",
	secondary: "#F9F6FF",
	textBlack: "#1C1C1C",
	textGray: "#7E7E7E",
	darkbg: "#1E1730",
	white: "#ffffff",
	black: "#000000",
	tundora: "#454545",
	toreaBay: "#112596",
	cello: "#1f275f",
	luckyPoint: "#193076",
	biscay: "#183B6A",
	bananaMania: "#fbeea8",
	malibu: "#59d2ff",
	dodgerBlue: "#2eadf6",
	anakiwa: "#80ddff",
	anakiwaLight: "#afe5ff",
	onahau: "#c6f0ff",
	indigo: "#3a73c0",
	waterloo: "#828896",
	boulder: "#757575",
	gray: "#7e7e7e",
	lightGray: "#E4E4E4",
	dustyGray: "#9c9c9c",
	alabaster: "#F7F7F7",
	athensGray: "#F0F3F5",
	athensGrayLight: "#f9f9fb",
	seaShell: "#f1f1f1",
	alto: "#dadada",
	silver: "#cccccc",
	astronaut: "#263276",
	mineShaft: "#333333",
	mineShaftDark: "#222222",
	ronchi: "#f2bd4a",
	monaLisa: "#fea08e",
	carnation: "#f55659",
	codGray: "#191919",
	jordyBlue: "#75abf3",
	congressBlue: "#003e91",
	frenchPass: "#b7f0ff",
	amaranth: "#ea2062",
	razzmatazz: "#F21976",
	funBlue: "#1D5EB5",
	funBlueDark: "#1b51a0",
	mariner: "#2077cb",
	patternsBlue: "#DCF3FF",
	royalBlue: "#3285e7",
	havelockBlue: "#3d83d9",
	stTropaz: "#2858a2",
	stTropazLight: "#2b5ea3",
	mySin: "#FFBB28",
	coral: "#FF8042",
	azureResidance: "#0088FE",
	periwinkle: "#C7D6FF",
	azureRadiance: "#0b7cf8",
	doveGray: "#676767",
	dullGray: "#ADADAD",
	cornsilk: "#FFF3DE",
	btnGray: "#BEBEBE",
	brightGray: "#E9E9E9",
	rajah: "#FFAA5C",
	magnolia: "#F6F2FF",
	pastelPurple: "#967DCC",
	chartAccent: "#E5D4FF",
	chartAccentText: "#9B6BF5",
	chartSwpPhase: "#B8DAFF",
	chartSustainMarker: "#EF4444",
	chartCursor: {
		fill: "rgba(103, 37, 244, 0.08)",
		stroke: "#6725F4"
	},
	jetBlack: "#363636",
	cultured: "#F6F5F1",
	deepPeach: "#FFCBA5",
	eerieBlack: "#1D1D1F",
	vodka: "#C4BAFF",
	platinum: "#E6E6E6",
	success: "#14B195",
}

export default colors
